import React, { useEffect } from 'react';
import T from 'prop-types';
import { hot } from 'react-hot-loader/root';
import ErrorBoundary from './global/ErrorBoundary';
import AbsoluteSessionTimeout from './global/AbsoluteSessionTimeout';
import Segments from './segments';
import SessionTimeout from 'srcAlias/client/global/components/SessionTimeout';
import hooks from 'hooksAlias';
import {
  eventBus,
  FormLayout,
  EventBusBridge,
  TrackingWrapper,
} from '@piggybank/core';
import { useSelector, useDispatch } from 'react-redux';
import { selectSessionId } from 'srcAlias/client/state/selectors';
import getSpecs from 'configFolderAlias/analytics';

import translations from 'contentAlias';
import config from 'configAlias';

import {
  initEvent,
  piggybankEvent,
  errorEvent,
} from './state/actions/eventActions';
import { Locale } from './locale';
import { get } from 'lodash-es';

const track = (event) => {
  if (event) {
    const { content } = event;
    const isViewEvent = get(event, 'rule.isViewEvent', false);
    // eslint-disable-next-line no-console
    console.log(
      `${isViewEvent ? 'window.TMS.trackView' : 'window.TMS.trackEvent'}`,
      content
    );
  }
};

export const App = () => {
  const dispatch = useDispatch();
  const sessionId = useSelector(selectSessionId);
  const AppParentComponent = get(
    hooks,
    'parent.AppParentComponent',
    () => null
  );
  useEffect(() => {
    dispatch(initEvent());
  }, []);

  useEffect(() => {
    const unsubscribe = eventBus.subscribe((action) => {
      if (
        /^onNavigate|onChange|onClose|onOpen|onClick|onError$/.test(action.type)
      ) {
        dispatch(piggybankEvent({ ...action, translations }));
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <TrackingWrapper
      // eslint-disable-next-line no-console
      onTrackingEvent={(events) => events.map((e) => track(e))}
      specs={getSpecs(sessionId)}
    >
      <EventBusBridge>
        <Locale translations={translations} culture={config.culture}>
          <AppParentComponent>
            <FormLayout>
              <ErrorBoundary
                title="An error occurred"
                setError={(data = {}) => dispatch(errorEvent(data))}
                appConfig={config.appConfig}
              >
                <AbsoluteSessionTimeout>
                  <SessionTimeout />
                  <Segments config={config.segments} />
                </AbsoluteSessionTimeout>
              </ErrorBoundary>
            </FormLayout>
          </AppParentComponent>
        </Locale>
      </EventBusBridge>
    </TrackingWrapper>
  );
};

App.propTypes = {
  store: T.object,
};

export default hot(App);
